exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ml-15[data-v-c9721e7e]{margin-left:15px}.fl-r[data-v-c9721e7e]{float:right}.mr-20[data-v-c9721e7e]{margin-right:20px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-c9721e7e","scoped":true,"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/consumablesStock/indateWarning/index.vue
// module id = dQ7b
// module chunks = 45 239